import { fg } from '@atlaskit/platform-feature-flags/fg';

import { useOverflowObserver as useLegacyOverflowObserver } from './legacy';
import {
	type UseOverflowObserverProps,
	useOverflowObserver as useNextOverflowObserver,
} from './next';

export const useOverflowObserver = (props: UseOverflowObserverProps): string[] => {
	const useNextImplementation = fg('rovo_fps_fix_filter_overflow_flash');
	const legacyVisibleItems = useLegacyOverflowObserver({
		...props,
		enabled: !useNextImplementation,
	});
	const nextVisibleItems = useNextOverflowObserver({
		...props,
		enabled: useNextImplementation,
	});

	return useNextImplementation ? nextVisibleItems : legacyVisibleItems;
};
